import { Colors, Shadows, Fonts } from './theme'

const MuiThemeOverrides = {
  palette: {
    primary: {
      light: Colors.Palette.primaryLighterColor,
      main: Colors.Palette.primaryColor,
      dark: Colors.Palette.primaryDarkerColor,
      contrastText: Colors.Palette.contrastTextColor
    },
    secondary: { // a hack to hide material ui items that require an enum for color
      main: Colors.Palette.secondaryColor
    },
    error: {
      main: Colors.Palette.primaryColor
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: Fonts.primaryFontFamily
  },
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '1rem'// looks large but gets too small when floating label is fixed :(
      }
    },
    MuiInput: {
      root: {
        fontSize: '1rem'
      }
    },
    MuiSelect: {
      root: {
        fontSize: '0.77rem'
      }
    },
    MuiPicker: {
      root: {
        fontSize: '0.77rem'
      }
    },
    MuiCard: {
      root: {
        borderRadius: 0
      }
    },
    MuiPaper: {
      root: {
        boxShadow: `${Shadows.primaryShadow}, ${Shadows.secondaryShadow}`
      }
    },
    MuiTab: {
      root: {
        maxWidth: 'auto',
        fontWeight: 'auto',
        minHeight: 'auto'
      }
    },
    MuiTabs: {
      root: {
        minHeight: 'auto'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '1rem'
      }
    }

  }// end of overrides
}

export default MuiThemeOverrides



// WEBPACK FOOTER //
// ./src/muiTheme.js